export function financeTokenLabel(token?: string): string | undefined {
    return token && /^TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t$/i.test(token) ? "USDT" : token;
}

export function formatFinanceMoney(value?: {atomic: string; scale: number; token?: string}): string {
    if (!value) return "—";
    const raw = value.atomic;
    const negative = raw.startsWith("-");
    const digits = (negative ? raw.slice(1) : raw).padStart(value.scale + 1, "0");
    const point = value.scale ? `${digits.slice(0, -value.scale)}.${digits.slice(-value.scale)}` : digits;
    const token = financeTokenLabel(value.token);
    return `${negative ? "-" : ""}${point}${token ? ` ${token}` : ""}`;
}

// formatFinanceAmount writes an amount the Russian way: thin groups, a decimal
// comma and a real minus. It rounds half away from zero to `digits`; pass the
// value's own scale to show it exactly. `sign` adds a plus to positive values.
export function formatFinanceAmount(value?: {atomic: string; scale: number}, {digits = 2, sign = false}: {digits?: number; sign?: boolean} = {}): string {
    if (!value) return "—";
    let n: bigint;
    try { n = BigInt(value.atomic); } catch { return "—"; }
    const negative = n < 0n;
    if (negative) n = -n;
    const keep = Math.min(digits, value.scale);
    if (value.scale > keep) {
        const divisor = 10n ** BigInt(value.scale - keep);
        n = (n + divisor / 2n) / divisor;
    }
    const text = n.toString().padStart(keep + 1, "0");
    const whole = text.slice(0, text.length - keep).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const fraction = (keep ? text.slice(-keep) : "").padEnd(digits, "0");
    const prefix = n === 0n ? "" : negative ? "−" : sign ? "+" : "";
    return `${prefix}${whole}${fraction ? `,${fraction}` : ""}`;
}

export function formatFinanceRub(value?: {atomic: string; scale: number}): string {
    return value ? `${formatFinanceAmount(value).replace(/,00$/, "")} ₽` : "—";
}
